import { ReactNode } from 'react';
import { AuthProvider } from '@/context/auth';
import { TranslationProvider } from '@/context/TranslationContext';
import { ThemeProvider } from '@/context/ThemeContext';
import { TooltipProvider } from '@/components/ui/tooltip';

interface DelayedProvidersProps {
  children: ReactNode;
}

const DelayedProviders = ({ children }: DelayedProvidersProps) => {
  return (
    <TranslationProvider>
      <AuthProvider>
        <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
          <TooltipProvider>
            {children}
          </TooltipProvider>
        </ThemeProvider>
      </AuthProvider>
    </TranslationProvider>
  );
};

export default DelayedProviders;